const shared = {
  fr: {
    backSite: 'Retour au site',
    logout: 'Déconnexion',
    welcome: 'Bonjour',
    overview: 'Vue d’ensemble',
    profile: 'Profil',
    save: 'Enregistrer',
    saved: 'Profil mis à jour',
    refresh: 'Actualiser',
    edit: 'Modifier le profil',
    back: 'Retour',
    empty: 'Aucun élément pour le moment.',
    actions: 'Actions',
    assign: 'Assigner',
    assignTo: 'Assigner à',
    changeStatus: 'Changer le statut',
    view: 'Voir',
    upload: 'Déposer un fichier',
    startMission: 'Démarrer',
    markReady: 'Marquer prêt',
    markDelivered: 'Marquer livré',
    addTranslator: 'Ajouter un traducteur',
    editProfile: 'Modifier le profil',
    availAvailable: 'Disponible',
    availBusy: 'Occupé',
    availUnavailable: 'Indisponible',
    specialties: 'Spécialités',
    langPairs: 'Paires de langues',
    experience: 'Années d’expérience',
    sworn: 'Assermenté',
    bio: 'Bio',
    pageRate: 'Tarif / page',
    availability: 'Disponibilité',
    timeline: 'Suivi',
    deliverables: 'Livrables',
    orderDetail: 'Détail commande',
    missionDetail: 'Détail mission',
    noTranslator: 'Aucun traducteur',
    selectTranslator: 'Choisir un traducteur',
    confirmAssign: 'Confirmer l’assignation',
    fromLang: 'De',
    toLang: 'Vers',
    addPair: 'Ajouter une paire',
    assignHowTitle: 'Comment une commande est affectée',
    assignHowText: 'L’admin ouvre la commande, choisit un traducteur dont les paires De→Vers correspondent, puis confirme. Une mission est créée automatiquement.',
    matchLangs: 'Traducteurs compatibles avec',
    noMatch: 'Aucun traducteur actif pour cette paire. Affichage de tous les traducteurs actifs.',
    clientInfoTitle: 'Vos infos utiles',
    clientInfoOrders: 'Suivez chaque commande : pending → assigned → en cours → prêt → livré.',
    clientInfoFiles: 'Quand le statut est « Prêt » ou « Livré », téléchargez vos documents traduits ici.',
    translatorInfoTitle: 'Votre activité',
    translatorInfoPairs: 'Déclarez précisément vos paires : langue source (De) → langue cible (Vers).',
    translatorInfoMissions: 'Une mission apparaît ici seulement après assignation admin.',
    howItWorks: 'Comment ça marche',
    matchScore: 'Score de compatibilité',
    payment: {
      unpaid: 'Non payé',
      pending: 'Paiement en cours',
      paid: 'Payé',
      refunded: 'Remboursé',
      failed: 'Échoué',
    },
    priority: {
      normal: 'Normale',
      high: 'Haute',
      urgent: 'Urgente',
    },
    status: {
      pending: 'En attente',
      in_progress: 'En cours',
      ready: 'Prêt',
      delivered: 'Livré',
      assigned: 'Assigné',
      answered: 'Répondu',
      sent: 'Envoyé',
      accepted: 'Accepté',
      rejected: 'Refusé',
      refused: 'Refusé',
      issued: 'Émise',
      paid: 'Payée',
      draft: 'Brouillon',
      active: 'Actif',
      busy: 'Occupé',
      unavailable: 'Indisponible',
      cancelled: 'Annulé',
      correction_requested: 'Correction demandée',
      validated: 'Validé',
    },
    accept: 'Accepter',
    reject: 'Refuser',
    send: 'Envoyer',
    cancel: 'Annuler',
    demoHint: 'Comptes démo',
    roleClient: 'Client',
    roleTranslator: 'Traducteur',
    roleAdmin: 'Admin',
    roleLegal: 'Vérificateur',
    client: {
      title: 'Client',
      navHome: 'Tableau de bord',
      navOrders: 'Mes commandes',
      navQuotes: 'Mes devis',
      navInvoices: 'Factures',
      navMessages: 'Messages',
      navProfile: 'Mon profil',
      homeTitle: 'Votre espace Tarjemlek',
      homeSubtitle: 'Suivez vos commandes, devis et documents certifiés.',
      statOrders: 'Commandes',
      statQuotes: 'Devis',
      statReady: 'Documents prêts',
      ctaOrder: 'Nouvelle commande',
      ctaQuote: 'Demander un devis',
      recentOrders: 'Commandes récentes',
      ordersTitle: 'Mes commandes',
      ordersSubtitle: 'Historique et statut de vos traductions.',
      colId: 'N°',
      colDocument: 'Document',
      colLangs: 'Langues',
      colStatus: 'Statut',
      colPrice: 'Prix',
      colDate: 'Date',
      quotesTitle: 'Mes devis',
      quotesSubtitle: 'Demandes de devis en cours et répondus.',
      colType: 'Type',
      acceptQuote: 'Accepter',
      rejectQuote: 'Refuser',
      invoicesTitle: 'Mes factures',
      invoicesSubtitle: 'Factures émises pour vos commandes.',
      messagesTitle: 'Messagerie',
      messagesSubtitle: 'Échangez avec l’équipe Tarjemlek.',
      messageLabel: 'Votre message',
      sendMessage: 'Envoyer',
      recipient: 'Destinataire',
      administration: 'Administration',
      profileTitle: 'Mon profil',
      profileSubtitle: 'Mettez à jour vos informations de contact.',
      fieldName: 'Nom complet',
      fieldEmail: 'Email',
      fieldPhone: 'Téléphone',
      fieldCity: 'Ville',
      detailTitle: 'Détail de la commande',
      detailSubtitle: 'Suivi et livrables de votre traduction.',
      backOrders: 'Retour aux commandes',
      statProgress: 'En traitement',
      searchOrders: 'Rechercher une commande…',
      filterAll: 'Toutes',
      kpiAll: 'Total compte',
      kpiProgress: 'En attente ou en cours',
      kpiReady: 'Prêts / livrés',
      kpiQuotes: 'Demandes ouvertes',
    },
    translator: {
      title: 'Traducteur',
      navHome: 'Tableau de bord',
      navMissions: 'Missions',
      navDocs: 'Documents',
      navProfile: 'Mon profil',
      homeTitle: 'Vos missions',
      homeSubtitle: 'Gérez vos traductions assignées et deadlines.',
      statOpen: 'Missions ouvertes',
      statProgress: 'En cours',
      statDone: 'Livrées',
      statDueSoon: 'Échéance < 48h',
      statOverdue: 'En retard',
      recentMissions: 'Missions récentes',
      priorityMissions: 'À traiter en priorité',
      missionsTitle: 'Missions',
      missionsSubtitle: 'Toutes les missions qui vous sont assignées.',
      colClient: 'Client',
      colDeadline: 'Échéance',
      docsTitle: 'Documents',
      docsSubtitle: 'Fichiers source, brouillons et livrables.',
      colFile: 'Fichier',
      colMission: 'Mission',
      colKind: 'Type',
      kindSource: 'Source',
      kindDraft: 'Brouillon',
      kindFinal: 'Final',
      profileTitle: 'Mon profil traducteur',
      profileSubtitle: 'Compétences, paires de langues et disponibilité.',
      updateStatus: 'Mettre à jour',
      uploadFinal: 'Envoyer le document final',
      searchMissions: 'Rechercher une mission…',
      filterAll: 'Toutes',
      kpiOpen: 'Assignées, non démarrées',
      kpiProgress: 'En cours de traduction',
      kpiDueSoon: 'À livrer bientôt',
      kpiOverdue: 'Deadline dépassée',
      respondTitle: 'Répondre à la mission',
      respondHint: 'Acceptez ou refusez avant de démarrer le travail.',
      acceptMission: 'Accepter',
      refuseMission: 'Refuser',
      recipient: 'Destinataire',
      administration: 'Administration',
    },
    admin: {
      title: 'Admin',
      navHome: 'Tableau de bord',
      navOrders: 'Commandes',
      navQuotes: 'Devis',
      navInvoices: 'Factures',
      navMessages: 'Messages',
      navLanguages: 'Langues',
      navServices: 'Services',
      navUsers: 'Utilisateurs',
      navTranslators: 'Traducteurs',
      navVerifiers: 'Vérificateurs',
      homeTitle: 'Administration',
      homeSubtitle: 'Pilotage des commandes, utilisateurs et réseau.',
      statOrders: 'Commandes',
      statUsers: 'Utilisateurs',
      statTranslators: 'Traducteurs',
      statPending: 'En attente',
      statOverdue: 'En retard',
      statDueSoon: 'Échéance < 48h',
      statPipeline: 'Pipeline',
      statInProgress: 'En cours',
      statReady: 'Prêtes',
      kpiQueueHint: 'À assigner',
      kpiOverdueHint: 'Action immédiate',
      kpiDueSoonHint: 'Sous 48 heures',
      kpiUnpaid: 'Impayées',
      pendingQueue: 'File d’attente',
      urgentTitle: 'Prioritaires / urgentes',
      availableTranslators: 'Traducteurs dispo',
      overdueTag: 'En retard',
      dueSoonTag: 'Bientôt due',
      opsTitle: 'Centre opérations',
      opsText: 'Filtrez par statut / paiement, priorisez et assignez avec matching De→Vers.',
      recentOrders: 'Dernières commandes',
      ordersTitle: 'Commandes',
      ordersSubtitle: 'Suivi global, filtres et affectation intelligente.',
      colClient: 'Client',
      colTranslator: 'Traducteur',
      colTotal: 'Total',
      colPriority: 'Priorité',
      colPayment: 'Paiement',
      colStatus: 'Statut',
      colCode: 'Code',
      searchOrders: 'Code, document, langues…',
      searchUsers: 'Nom ou email…',
      searchTranslators: 'Nom, email, paires…',
      filterAll: 'Toutes',
      filterMatch: 'Compatibles',
      filterPaymentAll: 'Tous paiements',
      pickBest: 'Meilleur match',
      willCreateMission: 'Une mission sera créée avec le document source pour traduction.',
      assignNotes: 'Note pour le traducteur',
      assignNotesHint: 'Consignes, priorité, format attendu…',
      assignError: 'Impossible d’assigner. Réessayez.',
      cancel: 'Annuler',
      manageOrder: 'Gestion avancée',
      adminNotes: 'Notes internes',
      usersTitle: 'Utilisateurs',
      usersSubtitle: 'Comptes enregistrés sur la plateforme.',
      colName: 'Nom',
      colEmail: 'Email',
      colRole: 'Rôle',
      translatorsTitle: 'Traducteurs',
      translatorsSubtitle: 'Réseau de traducteurs et disponibilité.',
      colLangs: 'Langues',
      colMissions: 'Missions',
      assignTitle: 'Assigner un traducteur',
      manageProfiles: 'Gérer les profils',
      createTranslator: 'Créer un traducteur',
      password: 'Mot de passe temporaire',
      quotesTitle: 'Devis',
      quotesSubtitle: 'Créez, tarifiez et envoyez les devis aux clients.',
      createQuote: 'Créer un devis',
      answerQuote: 'Tarifer / envoyer',
      sendQuote: 'Envoyer au client',
      deadline: 'Échéance',
      serviceType: 'Type',
      message: 'Message',
      languagesTitle: 'Langues',
      languagesSubtitle: 'Catalogue des langues proposées.',
      addLanguage: 'Ajouter une langue',
      servicesTitle: 'Services',
      servicesSubtitle: 'Catalogue des services offerts.',
      addService: 'Ajouter un service',
      serviceTitle: 'Titre',
      serviceCategory: 'Catégorie',
      catTranslation: 'Traduction',
      catInterpreting: 'Interprétariat',
      invoicesTitle: 'Factures',
      invoicesSubtitle: 'Émission et suivi des paiements.',
      createInvoice: 'Créer une facture',
      markPaid: 'Marquer payée',
      messagesTitle: 'Messages',
      messagesSubtitle: 'Conversations avec les clients et les professionnels.',
      sendMessage: 'Envoyer',
      thread: 'Fil',
      allThreads: 'Tous les fils',
      recipient: 'Destinataire',
      administration: 'Administration',
      activate: 'Activer',
      deactivate: 'Désactiver',
      delete: 'Supprimer',
      statDone: 'Terminées',
      statRevenue: 'Chiffre d’affaires',
      statPendingPayments: 'Paiements en attente',
      statNewClients: 'Nouveaux clients',
      statActivePros: 'Traducteurs & interprètes actifs',
      hintNewClients: '30 derniers jours',
      hintInterpreters: 'interprètes',
      hintRevenue: 'Commandes payées',
      hintPaymentsAmount: 'TND à encaisser',
      alertsTitle: 'Alertes & actions à traiter',
      alertUnassigned: 'Commandes sans professionnel affecté',
      alertApplications: 'Candidatures à valider',
      alertReviews: 'Documents en attente de vérification',
      alertPayments: 'Paiements en attente',
      alertDueSoon: 'Commandes dont le délai approche',
      noAlerts: 'Aucune alerte — tout est en ordre.',
      chartsTitle: 'Activité & répartition',
      chartOrders: 'Commandes par période',
      chartRevenue: 'Chiffre d’affaires par période',
      chartServices: 'Commandes par type de service',
      chartCategories: 'Traduction / Interprétariat',
      last6Months: '6 derniers mois',
      activityTitle: 'Activité récente',
      recentPayments: 'Derniers paiements',
      recentApplications: 'Nouvelles candidatures',
      recentDocuments: 'Nouveaux documents à traiter',
      pendingReviewsTitle: 'Vérifications en attente',
      colAmount: 'Montant',
      colDate: 'Date',
    },
    legal: {
      title: 'Vérificateur',
      navHome: 'Tableau de bord',
      navVerifications: 'Mes vérifications',
      navProfile: 'Mon profil',
      homeTitle: 'Vos vérifications',
      homeSubtitle: 'Gérez les contrôles juridiques et notariaux assignés.',
      statToReview: 'À vérifier',
      statCorrections: 'Corrections',
      statValidated: 'Validés',
      statDueSoon: 'Échéance < 48h',
      statOverdue: 'En retard',
      recentVerifications: 'Vérifications récentes',
      urgentVerifications: 'Vérifications urgentes',
      verificationsTitle: 'Mes vérifications',
      verificationsSubtitle: 'Toutes les commandes en attente de contrôle.',
      colClient: 'Client',
      colDocument: 'Document',
      colLangs: 'Langues',
      colStatus: 'Statut',
      colDeadline: 'Échéance',
      colType: 'Type',
      filterAll: 'Toutes',
      filterPending: 'À vérifier',
      filterCorrection: 'Corrections',
      filterValidated: 'Validées',
      detailTitle: 'Détail de la vérification',
      detailSubtitle: 'Contrôlez les documents et donnez votre avis.',
      originalDocs: 'Documents originaux',
      translatedDocs: 'Traductions',
      checklist: 'Checklist',
      comments: 'Commentaires',
      addComment: 'Ajouter une observation',
      requestCorrection: 'Demander une correction',
      validate: 'Valider',
      reject: 'Refuser',
      correctionReason: 'Motif de la correction',
      rejectReason: 'Motif du refus',
      reasonRequired: 'Un motif est obligatoire',
      profileTitle: 'Profil vérificateur',
      profileSubtitle: 'Informations professionnelles visibles par l’équipe.',
    },
  },
  ar: {
    backSite: 'العودة إلى الموقع',
    logout: 'تسجيل الخروج',
    welcome: 'مرحباً',
    overview: 'نظرة عامة',
    profile: 'الملف الشخصي',
    save: 'حفظ',
    saved: 'تم تحديث الملف',
    refresh: 'تحديث',
    edit: 'تعديل الملف الشخصي',
    back: 'رجوع',
    empty: 'لا توجد عناصر حالياً.',
    actions: 'إجراءات',
    assign: 'تعيين',
    assignTo: 'تعيين إلى',
    changeStatus: 'تغيير الحالة',
    view: 'عرض',
    upload: 'رفع ملف',
    startMission: 'بدء',
    markReady: 'جاهز',
    markDelivered: 'تم التسليم',
    addTranslator: 'إضافة مترجم',
    editProfile: 'تعديل الملف',
    send: 'Envoyer',
    cancel: 'Annuler',
    specialties: 'التخصصات',
    langPairs: 'أزواج اللغات',
    experience: 'سنوات الخبرة',
    sworn: 'محلف',
    bio: 'نبذة',
    pageRate: 'السعر / صفحة',
    availability: 'التوفر',
    timeline: 'المتابعة',
    deliverables: 'التسليمات',
    orderDetail: 'تفاصيل الطلب',
    missionDetail: 'تفاصيل المهمة',
    noTranslator: 'لا يوجد مترجم',
    selectTranslator: 'اختر مترجماً',
    confirmAssign: 'تأكيد التعيين',
    matchScore: 'درجة التوافق',
    payment: {
      unpaid: 'غير مدفوع',
      pending: 'قيد الدفع',
      paid: 'مدفوع',
      refunded: 'مسترد',
      failed: 'فشل',
    },
    priority: {
      normal: 'عادية',
      high: 'عالية',
      urgent: 'عاجلة',
    },
    status: {
      pending: 'قيد الانتظار',
      in_progress: 'قيد التنفيذ',
      ready: 'جاهز',
      delivered: 'تم التسليم',
      assigned: 'معيّن',
      answered: 'تم الرد',
      sent: 'مُرسل',
      accepted: 'مقبول',
      rejected: 'مرفوض',
      refused: 'مرفوض',
      issued: 'صادرة',
      paid: 'مدفوعة',
      draft: 'مسودة',
      active: 'نشط',
      busy: 'مشغول',
      unavailable: 'غير متاح',
      cancelled: 'ملغى',
      correction_requested: 'Correction demandée',
      validated: 'Validé',
    },
    demoHint: 'حسابات تجريبية',
    roleClient: 'عميل',
    roleTranslator: 'مترجم',
    roleAdmin: 'مدير',
    roleLegal: 'Vérificateur',
    client: {
      title: 'عميل',
      navHome: 'لوحة التحكم',
      navOrders: 'طلباتي',
      navQuotes: 'عروض الأسعار',
      navInvoices: 'الفواتير',
      navMessages: 'الرسائل',
      navProfile: 'ملفي',
      homeTitle: 'مساحتك في ترجملك',
      homeSubtitle: 'تابع طلباتك وعروض الأسعار والوثائق المعتمدة.',
      statOrders: 'الطلبات',
      statQuotes: 'عروض الأسعار',
      statReady: 'وثائق جاهزة',
      ctaOrder: 'طلب جديد',
      ctaQuote: 'طلب عرض أسعار',
      recentOrders: 'أحدث الطلبات',
      ordersTitle: 'طلباتي',
      ordersSubtitle: 'سجل وحالة ترجماتك.',
      colId: 'الرقم',
      colDocument: 'الوثيقة',
      colLangs: 'اللغات',
      colStatus: 'الحالة',
      colPrice: 'السعر',
      colDate: 'التاريخ',
      quotesTitle: 'عروض الأسعار',
      quotesSubtitle: 'الطلبات الجارية والمجاب عنها.',
      colType: 'النوع',
      acceptQuote: 'قبول',
      rejectQuote: 'رفض',
      invoicesTitle: 'فواتيري',
      invoicesSubtitle: 'الفواتير الصادرة لطلباتك.',
      messagesTitle: 'الرسائل',
      messagesSubtitle: 'تواصل مع فريق ترجملك.',
      messageLabel: 'رسالتك',
      sendMessage: 'إرسال',
      recipient: 'المستلم',
      administration: 'الإدارة',
      profileTitle: 'ملفي الشخصي',
      profileSubtitle: 'حدّث معلومات الاتصال.',
      fieldName: 'الاسم الكامل',
      fieldEmail: 'البريد',
      fieldPhone: 'الهاتف',
      fieldCity: 'المدينة',
      statProgress: 'قيد المعالجة',
      searchOrders: 'ابحث عن طلب…',
      filterAll: 'الكل',
      kpiAll: 'إجمالي الحساب',
      kpiProgress: 'قيد الانتظار أو التنفيذ',
      kpiReady: 'جاهز / مسلّم',
      kpiQuotes: 'طلبات مفتوحة',
    },
    translator: {
      title: 'مترجم',
      navHome: 'لوحة التحكم',
      navMissions: 'المهام',
      navDocs: 'الوثائق',
      navProfile: 'ملفي',
      homeTitle: 'مهامك',
      homeSubtitle: 'أدِر الترجمات المعيّنة والمواعيد النهائية.',
      statOpen: 'مهام مفتوحة',
      statProgress: 'قيد التنفيذ',
      statDone: 'مسلّمة',
      statDueSoon: 'موعد < 48س',
      statOverdue: 'متأخرة',
      recentMissions: 'أحدث المهام',
      priorityMissions: 'أولوية المعالجة',
      missionsTitle: 'المهام',
      missionsSubtitle: 'كل المهام المعيّنة لك.',
      colClient: 'العميل',
      colDeadline: 'الموعد',
      docsTitle: 'الوثائق',
      docsSubtitle: 'ملفات المصدر والمسودات والتسليمات.',
      colFile: 'الملف',
      colMission: 'المهمة',
      colKind: 'النوع',
      kindSource: 'مصدر',
      kindDraft: 'مسودة',
      kindFinal: 'نهائي',
      profileTitle: 'ملف المترجم',
      profileSubtitle: 'معلومات يراها فريق ترجملك.',
      searchMissions: 'ابحث عن مهمة…',
      filterAll: 'الكل',
      kpiOpen: 'معيّنة ولم تبدأ',
      kpiProgress: 'قيد الترجمة',
      kpiDueSoon: 'تسليم قريب',
      kpiOverdue: 'تجاوز الموعد',
      respondTitle: 'الرد على المهمة',
      respondHint: 'اقبل أو ارفض قبل بدء العمل.',
      acceptMission: 'قبول',
      refuseMission: 'رفض',
      recipient: 'المستلم',
      administration: 'الإدارة',
    },
    admin: {
      title: 'إدارة',
      navHome: 'لوحة التحكم',
      navOrders: 'الطلبات',
      navQuotes: 'عروض الأسعار',
      navInvoices: 'الفواتير',
      navMessages: 'الرسائل',
      navLanguages: 'اللغات',
      navServices: 'الخدمات',
      navUsers: 'المستخدمون',
      navTranslators: 'المترجمون',
      navVerifiers: 'Vérificateurs',
      homeTitle: 'الإدارة',
      homeSubtitle: 'إدارة الطلبات والمستخدمين والشبكة.',
      statOrders: 'الطلبات',
      statUsers: 'المستخدمون',
      statTranslators: 'المترجمون',
      statPending: 'قيد الانتظار',
      statOverdue: 'متأخرة',
      statDueSoon: 'موعد < 48س',
      statPipeline: 'القيمة',
      statInProgress: 'قيد التنفيذ',
      statReady: 'جاهزة',
      kpiQueueHint: 'بانتظار التعيين',
      kpiOverdueHint: 'إجراء فوري',
      kpiDueSoonHint: 'خلال 48 ساعة',
      kpiUnpaid: 'غير مدفوعة',
      pendingQueue: 'قائمة الانتظار',
      urgentTitle: 'عاجلة / أولوية',
      availableTranslators: 'مترجمون متاحون',
      overdueTag: 'متأخر',
      dueSoonTag: 'قريب',
      opsTitle: 'مركز العمليات',
      opsText: 'صفِّ حسب الحالة/الدفع، حدّد الأولوية وعيّن بالمطابقة.',
      recentOrders: 'آخر الطلبات',
      ordersTitle: 'الطلبات',
      ordersSubtitle: 'متابعة شاملة وفلاتر وتعيين ذكي.',
      colClient: 'العميل',
      colTranslator: 'المترجم',
      colTotal: 'الإجمالي',
      colPriority: 'الأولوية',
      colPayment: 'الدفع',
      colStatus: 'الحالة',
      searchOrders: 'رمز، وثيقة، لغات…',
      searchUsers: 'الاسم أو البريد…',
      searchTranslators: 'الاسم، البريد، الأزواج…',
      filterAll: 'الكل',
      filterMatch: 'متوافقون',
      filterPaymentAll: 'كل المدفوعات',
      pickBest: 'أفضل تطابق',
      willCreateMission: 'سيتم إنشاء مهمة مع وثيقة المصدر للترجمة.',
      assignNotes: 'ملاحظة للمترجم',
      assignNotesHint: 'تعليمات، أولوية، الصيغة المطلوبة…',
      assignError: 'تعذر التعيين. أعد المحاولة.',
      cancel: 'إلغاء',
      manageOrder: 'إدارة متقدمة',
      adminNotes: 'ملاحظات داخلية',
      usersTitle: 'المستخدمون',
      usersSubtitle: 'الحسابات المسجلة على المنصة.',
      colName: 'الاسم',
      colEmail: 'البريد',
      colRole: 'الدور',
      translatorsTitle: 'المترجمون',
      translatorsSubtitle: 'شبكة المترجمين والتوافر.',
      colLangs: 'اللغات',
      colMissions: 'المهام',
      quotesTitle: 'عروض الأسعار',
      quotesSubtitle: 'إنشاء وتسعير وإرسال العروض.',
      createQuote: 'إنشاء عرض',
      answerQuote: 'تسعير / إرسال',
      sendQuote: 'إرسال للعميل',
      deadline: 'الموعد',
      serviceType: 'النوع',
      message: 'رسالة',
      languagesTitle: 'اللغات',
      languagesSubtitle: 'كتالوج اللغات.',
      addLanguage: 'إضافة لغة',
      servicesTitle: 'الخدمات',
      servicesSubtitle: 'كتالوج الخدمات.',
      addService: 'إضافة خدمة',
      serviceTitle: 'العنوان',
      serviceCategory: 'الفئة',
      catTranslation: 'ترجمة',
      catInterpreting: 'ترجمة فورية',
      invoicesTitle: 'الفواتير',
      invoicesSubtitle: 'إصدار ومتابعة الدفع.',
      createInvoice: 'إنشاء فاتورة',
      markPaid: 'تعيين كمدفوعة',
      messagesTitle: 'الرسائل',
      messagesSubtitle: 'محادثات العملاء والمهنيين.',
      sendMessage: 'إرسال',
      thread: 'المحادثة',
      allThreads: 'كل المحادثات',
      recipient: 'المستلم',
      administration: 'الإدارة',
      activate: 'تفعيل',
      deactivate: 'تعطيل',
      delete: 'حذف',
      statDone: 'منتهية',
      statRevenue: 'رقم الأعمال',
      statPendingPayments: 'مدفوعات معلقة',
      statNewClients: 'عملاء جدد',
      statActivePros: 'مترجمون ومترجمون فوريون نشطون',
      hintNewClients: 'آخر 30 يوماً',
      hintInterpreters: 'مترجمون فوريون',
      hintRevenue: 'طلبات مدفوعة',
      hintPaymentsAmount: 'د.ت للتحصيل',
      alertsTitle: 'تنبيهات وإجراءات',
      alertUnassigned: 'طلبات بدون مهني معيّن',
      alertApplications: 'ترشيحات للتحقق',
      alertReviews: 'وثائق بانتظار التدقيق',
      alertPayments: 'مدفوعات معلقة',
      alertDueSoon: 'طلبات يقترب موعدها',
      noAlerts: 'لا تنبيهات — كل شيء على ما يرام.',
      chartsTitle: 'النشاط والتوزيع',
      chartOrders: 'الطلبات حسب الفترة',
      chartRevenue: 'رقم الأعمال حسب الفترة',
      chartServices: 'الطلبات حسب نوع الخدمة',
      chartCategories: 'ترجمة / ترجمة فورية',
      last6Months: 'آخر 6 أشهر',
      activityTitle: 'النشاط الأخير',
      recentPayments: 'آخر المدفوعات',
      recentApplications: 'ترشيحات جديدة',
      recentDocuments: 'وثائق جديدة للمعالجة',
      pendingReviewsTitle: 'تدقيقات معلقة',
      colAmount: 'المبلغ',
      colDate: 'التاريخ',
    },
    legal: {
      title: 'Vérificateur',
      navHome: 'Tableau de bord',
      navVerifications: 'Mes vérifications',
      navProfile: 'Mon profil',
      homeTitle: 'Vos vérifications',
      homeSubtitle: 'Gérez les contrôles juridiques et notariaux assignés.',
      statToReview: 'À vérifier',
      statCorrections: 'Corrections',
      statValidated: 'Validés',
      statDueSoon: 'Échéance < 48h',
      statOverdue: 'En retard',
      recentVerifications: 'Vérifications récentes',
      urgentVerifications: 'Vérifications urgentes',
      verificationsTitle: 'Mes vérifications',
      verificationsSubtitle: 'Toutes les commandes en attente de contrôle.',
      colClient: 'Client',
      colDocument: 'Document',
      colLangs: 'Langues',
      colStatus: 'Statut',
      colDeadline: 'Échéance',
      colType: 'Type',
      filterAll: 'Toutes',
      filterPending: 'À vérifier',
      filterCorrection: 'Corrections',
      filterValidated: 'Validées',
      detailTitle: 'Détail de la vérification',
      detailSubtitle: 'Contrôlez les documents et donnez votre avis.',
      originalDocs: 'Documents originaux',
      translatedDocs: 'Traductions',
      checklist: 'Checklist',
      comments: 'Commentaires',
      addComment: 'Ajouter une observation',
      requestCorrection: 'Demander une correction',
      validate: 'Valider',
      reject: 'Refuser',
      correctionReason: 'Motif de la correction',
      rejectReason: 'Motif du refus',
      reasonRequired: 'Un motif est obligatoire',
      profileTitle: 'Profil vérificateur',
      profileSubtitle: 'Informations professionnelles visibles par l’équipe.',
    },
  },
  en: {
    backSite: 'Back to site',
    logout: 'Log out',
    welcome: 'Hello',
    overview: 'Overview',
    profile: 'Profile',
    save: 'Save',
    saved: 'Profile updated',
    refresh: 'Refresh',
    edit: 'Edit profile',
    back: 'Back',
    empty: 'Nothing here yet.',
    actions: 'Actions',
    assign: 'Assign',
    assignTo: 'Assign to',
    changeStatus: 'Change status',
    view: 'View',
    upload: 'Upload file',
    startMission: 'Start',
    markReady: 'Mark ready',
    markDelivered: 'Mark delivered',
    addTranslator: 'Add translator',
    editProfile: 'Edit profile',
    send: 'Send',
    cancel: 'Cancel',
    specialties: 'Specialties',
    langPairs: 'Language pairs',
    experience: 'Years of experience',
    sworn: 'Sworn',
    bio: 'Bio',
    pageRate: 'Rate / page',
    availability: 'Availability',
    timeline: 'Timeline',
    deliverables: 'Deliverables',
    orderDetail: 'Order detail',
    missionDetail: 'Mission detail',
    noTranslator: 'No translator',
    selectTranslator: 'Select a translator',
    confirmAssign: 'Confirm assignment',
    fromLang: 'From',
    toLang: 'To',
    addPair: 'Add a pair',
    assignHowTitle: 'How an order is assigned',
    assignHowText: 'Admin opens the order, picks a translator whose From→To pairs match, then confirms. A mission is created automatically.',
    matchLangs: 'Translators matching',
    noMatch: 'No active translator for this pair. Showing all active translators.',
    clientInfoTitle: 'Useful info',
    clientInfoOrders: 'Track each order: pending → assigned → in progress → ready → delivered.',
    clientInfoFiles: 'When status is Ready or Delivered, download your translated files here.',
    translatorInfoTitle: 'Your activity',
    translatorInfoPairs: 'Declare precise pairs: source language (From) → target language (To).',
    translatorInfoMissions: 'A mission appears here only after admin assignment.',
    howItWorks: 'How it works',
    matchScore: 'Match score',
    payment: {
      unpaid: 'Unpaid',
      pending: 'Payment pending',
      paid: 'Paid',
      refunded: 'Refunded',
      failed: 'Failed',
    },
    priority: {
      normal: 'Normal',
      high: 'High',
      urgent: 'Urgent',
    },
    status: {
      pending: 'Pending',
      in_progress: 'In progress',
      ready: 'Ready',
      delivered: 'Delivered',
      assigned: 'Assigned',
      answered: 'Answered',
      sent: 'Sent',
      accepted: 'Accepted',
      rejected: 'Rejected',
      refused: 'Refused',
      issued: 'Issued',
      paid: 'Paid',
      draft: 'Draft',
      active: 'Active',
      busy: 'Busy',
      unavailable: 'Unavailable',
      cancelled: 'Cancelled',
      correction_requested: 'Correction requested',
      validated: 'Validated',
    },
    demoHint: 'Demo accounts',
    roleClient: 'Client',
    roleTranslator: 'Translator',
    roleAdmin: 'Admin',
    roleLegal: 'Verifier',
    client: {
      title: 'Client',
      navHome: 'Dashboard',
      navOrders: 'My orders',
      navQuotes: 'My quotes',
      navInvoices: 'Invoices',
      navMessages: 'Messages',
      navProfile: 'My profile',
      homeTitle: 'Your Tarjemlek space',
      homeSubtitle: 'Track orders, quotes and certified documents.',
      statOrders: 'Orders',
      statQuotes: 'Quotes',
      statReady: 'Ready documents',
      ctaOrder: 'New order',
      ctaQuote: 'Request a quote',
      recentOrders: 'Recent orders',
      ordersTitle: 'My orders',
      ordersSubtitle: 'History and status of your translations.',
      colId: 'ID',
      colDocument: 'Document',
      colLangs: 'Languages',
      colStatus: 'Status',
      colPrice: 'Price',
      colDate: 'Date',
      quotesTitle: 'My quotes',
      quotesSubtitle: 'Open and answered quote requests.',
      colType: 'Type',
      acceptQuote: 'Accept',
      rejectQuote: 'Reject',
      invoicesTitle: 'My invoices',
      invoicesSubtitle: 'Invoices issued for your orders.',
      messagesTitle: 'Messages',
      messagesSubtitle: 'Chat with the Tarjemlek team.',
      messageLabel: 'Your message',
      sendMessage: 'Send',
      recipient: 'Recipient',
      administration: 'Administration',
      profileTitle: 'My profile',
      profileSubtitle: 'Update your contact details.',
      fieldName: 'Full name',
      fieldEmail: 'Email',
      fieldPhone: 'Phone',
      fieldCity: 'City',
      detailTitle: 'Order detail',
      detailSubtitle: 'Track your translation and downloadables.',
      backOrders: 'Back to orders',
      statProgress: 'In process',
      searchOrders: 'Search an order…',
      filterAll: 'All',
      kpiAll: 'Account total',
      kpiProgress: 'Pending or in progress',
      kpiReady: 'Ready / delivered',
      kpiQuotes: 'Open requests',
    },
    translator: {
      title: 'Translator',
      navHome: 'Dashboard',
      navMissions: 'Missions',
      navDocs: 'Documents',
      navProfile: 'My profile',
      homeTitle: 'Your missions',
      homeSubtitle: 'Manage assigned translations and deadlines.',
      statOpen: 'Open missions',
      statProgress: 'In progress',
      statDone: 'Delivered',
      statDueSoon: 'Due < 48h',
      statOverdue: 'Overdue',
      recentMissions: 'Recent missions',
      priorityMissions: 'Priority queue',
      missionsTitle: 'Missions',
      missionsSubtitle: 'All missions assigned to you.',
      colClient: 'Client',
      colDeadline: 'Deadline',
      docsTitle: 'Documents',
      docsSubtitle: 'Source files, drafts and deliverables.',
      colFile: 'File',
      colMission: 'Mission',
      colKind: 'Type',
      kindSource: 'Source',
      kindDraft: 'Draft',
      kindFinal: 'Final',
      profileTitle: 'Translator profile',
      profileSubtitle: 'Details visible to the Tarjemlek team.',
      searchMissions: 'Search a mission…',
      filterAll: 'All',
      kpiOpen: 'Assigned, not started',
      kpiProgress: 'Being translated',
      kpiDueSoon: 'Due soon',
      kpiOverdue: 'Past deadline',
      respondTitle: 'Respond to mission',
      respondHint: 'Accept or refuse before starting work.',
      acceptMission: 'Accept',
      refuseMission: 'Refuse',
      recipient: 'Recipient',
      administration: 'Administration',
    },
    admin: {
      title: 'Admin',
      navHome: 'Dashboard',
      navOrders: 'Orders',
      navQuotes: 'Quotes',
      navInvoices: 'Invoices',
      navMessages: 'Messages',
      navLanguages: 'Languages',
      navServices: 'Services',
      navUsers: 'Users',
      navTranslators: 'Translators',
      navVerifiers: 'Verifiers',
      homeTitle: 'Administration',
      homeSubtitle: 'Manage orders, users and the translator network.',
      statOrders: 'Orders',
      statUsers: 'Users',
      statTranslators: 'Translators',
      statPending: 'Pending',
      statOverdue: 'Overdue',
      statDueSoon: 'Due < 48h',
      statPipeline: 'Pipeline',
      statInProgress: 'In progress',
      statReady: 'Ready',
      kpiQueueHint: 'To assign',
      kpiOverdueHint: 'Needs action now',
      kpiDueSoonHint: 'Within 48 hours',
      kpiUnpaid: 'Unpaid',
      pendingQueue: 'Assignment queue',
      urgentTitle: 'Urgent / priority',
      availableTranslators: 'Available translators',
      overdueTag: 'Overdue',
      dueSoonTag: 'Due soon',
      opsTitle: 'Operations hub',
      opsText: 'Filter by status/payment, set priority and assign with From→To matching.',
      recentOrders: 'Latest orders',
      ordersTitle: 'Orders',
      ordersSubtitle: 'Platform-wide tracking, filters and smart assignment.',
      colClient: 'Client',
      colTranslator: 'Translator',
      colTotal: 'Total',
      colPriority: 'Priority',
      colPayment: 'Payment',
      colStatus: 'Status',
      colCode: 'Code',
      searchOrders: 'Code, document, languages…',
      searchUsers: 'Name or email…',
      searchTranslators: 'Name, email, pairs…',
      filterAll: 'All',
      filterMatch: 'Compatible',
      filterPaymentAll: 'All payments',
      pickBest: 'Best match',
      willCreateMission: 'A mission will be created with the source document for translation.',
      assignNotes: 'Note for translator',
      assignNotesHint: 'Instructions, priority, expected format…',
      assignError: 'Could not assign. Try again.',
      cancel: 'Cancel',
      manageOrder: 'Advanced management',
      adminNotes: 'Internal notes',
      usersTitle: 'Users',
      usersSubtitle: 'Accounts registered on the platform.',
      colName: 'Name',
      colEmail: 'Email',
      colRole: 'Role',
      translatorsTitle: 'Translators',
      translatorsSubtitle: 'Translator network and availability.',
      colLangs: 'Languages',
      colMissions: 'Missions',
      assignTitle: 'Assign a translator',
      manageProfiles: 'Manage profiles',
      createTranslator: 'Create translator',
      password: 'Temporary password',
      quotesTitle: 'Quotes',
      quotesSubtitle: 'Create, price and send quotes to clients.',
      createQuote: 'Create quote',
      answerQuote: 'Price / send',
      sendQuote: 'Send to client',
      deadline: 'Deadline',
      serviceType: 'Type',
      message: 'Message',
      languagesTitle: 'Languages',
      languagesSubtitle: 'Offered language catalog.',
      addLanguage: 'Add language',
      servicesTitle: 'Services',
      servicesSubtitle: 'Offered services catalog.',
      addService: 'Add service',
      serviceTitle: 'Title',
      serviceCategory: 'Category',
      catTranslation: 'Translation',
      catInterpreting: 'Interpreting',
      invoicesTitle: 'Invoices',
      invoicesSubtitle: 'Issue and track payments.',
      createInvoice: 'Create invoice',
      markPaid: 'Mark paid',
      messagesTitle: 'Messages',
      messagesSubtitle: 'Conversations with clients and professionals.',
      sendMessage: 'Send',
      thread: 'Thread',
      allThreads: 'All threads',
      recipient: 'Recipient',
      administration: 'Administration',
      activate: 'Activate',
      deactivate: 'Deactivate',
      delete: 'Delete',
      statDone: 'Completed',
      statRevenue: 'Revenue',
      statPendingPayments: 'Pending payments',
      statNewClients: 'New clients',
      statActivePros: 'Active translators & interpreters',
      hintNewClients: 'Last 30 days',
      hintInterpreters: 'interpreters',
      hintRevenue: 'Paid orders',
      hintPaymentsAmount: 'TND to collect',
      alertsTitle: 'Alerts & actions',
      alertUnassigned: 'Orders without an assignee',
      alertApplications: 'Applications to review',
      alertReviews: 'Documents awaiting verification',
      alertPayments: 'Pending payments',
      alertDueSoon: 'Orders nearing deadline',
      noAlerts: 'No alerts — all clear.',
      chartsTitle: 'Activity & breakdown',
      chartOrders: 'Orders by period',
      chartRevenue: 'Revenue by period',
      chartServices: 'Orders by service type',
      chartCategories: 'Translation / Interpreting',
      last6Months: 'Last 6 months',
      activityTitle: 'Recent activity',
      recentPayments: 'Latest payments',
      recentApplications: 'New applications',
      recentDocuments: 'New documents to process',
      pendingReviewsTitle: 'Pending verifications',
      colAmount: 'Amount',
      colDate: 'Date',
    },
    legal: {
      title: 'Verifier',
      navHome: 'Dashboard',
      navVerifications: 'My verifications',
      navProfile: 'My profile',
      homeTitle: 'Your verifications',
      homeSubtitle: 'Manage assigned legal and notary reviews.',
      statToReview: 'To review',
      statCorrections: 'Corrections',
      statValidated: 'Validated',
      statDueSoon: 'Due < 48h',
      statOverdue: 'Overdue',
      recentVerifications: 'Recent verifications',
      urgentVerifications: 'Urgent verifications',
      verificationsTitle: 'My verifications',
      verificationsSubtitle: 'All orders pending review.',
      colClient: 'Client',
      colDocument: 'Document',
      colLangs: 'Languages',
      colStatus: 'Status',
      colDeadline: 'Deadline',
      colType: 'Type',
      filterAll: 'All',
      filterPending: 'To review',
      filterCorrection: 'Corrections',
      filterValidated: 'Validated',
      detailTitle: 'Verification detail',
      detailSubtitle: 'Review documents and submit your decision.',
      originalDocs: 'Original documents',
      translatedDocs: 'Translations',
      checklist: 'Checklist',
      comments: 'Comments',
      addComment: 'Add a comment',
      requestCorrection: 'Request correction',
      validate: 'Validate',
      reject: 'Reject',
      correctionReason: 'Correction reason',
      rejectReason: 'Rejection reason',
      reasonRequired: 'A reason is required',
      profileTitle: 'Verifier profile',
      profileSubtitle: 'Professional information visible to the team.',
    },
  },
};

export const dashboardFr = shared.fr;
export const dashboardAr = shared.ar;
export const dashboardEn = shared.en;
